export function randomArray( item: any, length: number = 100, min: number = 0 ) {
   return Array.from({ length: Math.floor( Math.random() * length + min )}, _ => new item() );
}
